import { FadeIn } from '~/components/subscription/branch-lp/fade-in'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import image5 from './images/5.jpg'
import image6 from './images/6.jpg'
import image7 from './images/7.jpg'

export const AdvantagesSection: React.FC = () => {
  const items = [
    {
      image: image1,
      alt: '花器に入れた状態のインテリアショット',
      headline: (
        <>
          花器に入れるだけで、
          <br />
          絵になる
        </>
      ),
      body: 'アレンジメントの知識は不要。花器に枝をそのまま入れるだけで、あなたの部屋に絵になる一角が生まれます。',
    },
    {
      image: image2,
      alt: '飾られた枝もの',
      headline: (
        <>
          長持ち、
          <br />
          なのに手間いらず
        </>
      ),
      body: '枝ものの多くは日持ちがよく、2〜4週間楽しめるものも。飾り替えの手間も少なく、日常的に飾るのにちょうどいいんです。',
    },
    {
      image: image3,
      alt: '部屋に飾った枝もの',
      headline: (
        <>
          大きいサイズ、
          <br />
          だから部屋が変わる
        </>
      ),
      body: '長さ約80cm。置くだけで部屋の印象が一気に変わるのは、このサイズ感があってこそ。持ち帰りが大変な枝ものも、定期便ならご自宅までお届け。',
    },
    {
      images: [
        { src: image4, alt: '春・桜の枝もの' },
        { src: image5, alt: '夏・ユーカリの枝もの' },
        { src: image6, alt: '秋・紅葉の枝もの' },
        { src: image7, alt: '冬・枝もの' },
      ],
      headline: (
        <>
          毎月、季節が
          <br />
          届く暮らし
        </>
      ),
      body: '桜、ドウダンツツジ、ユーカリ。定期便だから、選ぶ手間なく季節の移ろいをお家にいながら楽しめます。',
    },
  ]

  return (
    <section id="about" className="bg-bg pt-14 md:pt-20">
      {items.map((item, i) => (
        <FadeIn key={i}>
          <div className={`max-w-5xl mx-auto flex flex-col pb-16 md:pb-20 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
            <div className="w-full md:w-1/2 px-5 md:px-8">
              <div className="aspect-3/4 rounded-xl overflow-hidden">
                {item.images ? (
                  <div className="grid grid-cols-2 grid-rows-2 gap-0.5 w-full h-full">
                    {item.images.map((img, j) => (
                      <img key={j} src={img.src} alt={img.alt} className="w-full h-full object-cover" />
                    ))}
                  </div>
                ) : (
                  <img src={item.image} alt={item.alt} className="w-full h-full object-cover" />
                )}
              </div>
            </div>
            <div className="w-full md:w-1/2 flex items-center px-8 md:px-16 py-8 md:py-12">
              <div>
                <h2 className="text-[28px] md:text-[38px] font-medium text-black leading-[1.7]">{item.headline}</h2>
                <p className="mt-8 text-[15px] text-main leading-[1.9] max-w-sm">{item.body}</p>
              </div>
            </div>
          </div>
        </FadeIn>
      ))}
    </section>
  )
}
